import React from 'react'

const CadentierFormatorSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.538452" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17880)" />
    <path
      d="M31.842 50.5385C31.842 44.4405 31.842 38.4514 31.842 32.4078C37.8856 32.4078 43.9292 32.4078 50.0272 32.4078C50.0272 32.6256 50.0272 32.8434 50.0272 33.0612C50.0272 38.0158 50.0272 42.9704 50.0272 47.9795C50.0272 49.7762 49.2105 50.5385 47.4682 50.5385C42.5135 50.5385 37.5589 50.5385 32.6587 50.5385C32.3321 50.5385 32.1143 50.5385 31.842 50.5385Z"
      fill="white"
    />
    <path
      d="M49.9727 29.0321C39.9545 29.0321 29.9908 29.0321 19.9727 29.0321C19.9727 27.9432 19.9727 26.8542 19.9727 25.8198C19.9727 24.7853 19.9727 23.8052 19.9727 22.7708C19.9727 21.464 20.8982 20.5385 22.205 20.5385C30.7531 20.5385 39.2467 20.5385 47.7948 20.5385C48.9926 20.5385 49.8638 21.3551 49.9727 22.4441C49.9727 22.6074 49.9727 22.7708 49.9727 22.9341C49.9727 24.9486 49.9727 26.9631 49.9727 29.0321Z"
      fill="white"
    />
    <path
      d="M28.4663 32.4078C28.4663 38.4513 28.4663 44.4404 28.4663 50.5384C27.7585 50.5384 27.1051 50.5384 26.4518 50.5384C25.0362 50.5384 23.6206 50.5384 22.205 50.5384C20.8982 50.5384 19.9727 49.6673 19.9727 48.3061C19.9727 43.1337 19.9727 37.9613 19.9727 32.7344C19.9727 32.6255 19.9727 32.5166 20.0271 32.3533C22.8039 32.4078 25.5806 32.4078 28.4663 32.4078Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17880"
        x1="34.5455"
        y1="0.538452"
        x2="34.5455"
        y2="70.5385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB300" />
        <stop offset="1" stopColor="#E5A100" />
      </linearGradient>
    </defs>
  </svg>
)

export default CadentierFormatorSubcategory
